'use client';
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { format } from 'date-fns';
import { CalendarBlank, Clock } from '@phosphor-icons/react/dist/ssr';
import { getRegionalUrl } from '@/lib/utils';

interface RelatedArticles {
  heading: string;
  articles: {
    related_blog_translations_id: {
      status: string;
      tags: string[];
      name: string;
      published_date: string;
      author: string;
      banner: string;
      content: any;
      content_read_time: string;
      slug: string;
    };
  }[];
}

const RelatedArticles = ({ heading, articles }: RelatedArticles) => {
  const params = useParams<{ countryCode?: string }>();
  if (!articles) return;

  const formatTime = (date: string) => {
    const time = new Date(date);
    const formattedTime = format(time, 'dd/MM/yyyy');
    return formattedTime;
  };

  return (
    <div className="flex w-full max-w-desktop mx-auto  gap-5 pt-10 flex-col items-center justify-center">
      <h1 className="text-3xl font-bold">{heading}</h1>
      <div className=" lg:flex grid md:grid-cols-2 grid-cols-1 items-center justify-center flex-wrap gap-[24px]  mt-6">
        {articles?.map((item, index: number) => {
          return (
            item?.related_blog_translations_id?.status !== 'draft' && (
              <Link
                key={index}
                href={getRegionalUrl(
                  `/blog/${item?.related_blog_translations_id?.slug}`,
                  params?.countryCode
                )}
                className="flex lg:w-96 group w-full flex-col gap-1 md:gap-2 lg:gap-2 rounded-[10px] bg-off-white"
              >
                <div
                  // style={{ background: '#7275BA' }}
                  className="overflow-hidden h-52 w-full rounded-[10px] flex items-center justify-center"
                >
                  <div className="w-full h-full">
                    <Image
                      src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/${item?.related_blog_translations_id?.banner}`}
                      alt=""
                      width={500}
                      height={500}
                      quality={100}
                      className="h-full w-full object-cover"
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 lg:gap-4 p-3 pt-2">
                  <ul className="flex flex-wrap gap-3 font-semibold ">
                    {item?.related_blog_translations_id?.tags?.map(
                      (tag: any, index: number) => (
                        <li
                          className="rounded-3xl text-[#666D80] bg-white text-sm py-1 px-3"
                          key={index}
                        >
                          {tag}
                        </li>
                      )
                    )}
                  </ul>
                  <div>
                    <p className="line-clamp-2  h-[3em] font-semibold leading-normal text-[24px] group-hover:underline">
                      {item?.related_blog_translations_id?.name}
                    </p>
                  </div>
                  <div className="flex gap-3">
                    <span className="flex items-center gap-2">
                      <CalendarBlank size={20} color="#666D80" />

                      <p className="text-[#666D80] font-proxima_font text-[16px]">
                        {formatTime(
                          item?.related_blog_translations_id?.published_date
                        )}
                      </p>
                    </span>

                    <span className="text-[#666D80]"> | </span>
                    <span className="flex items-center gap-2">
                      <Clock size={20} color="#666D80" />

                      <p className="text-[#666D80] font-proxima_font text-[16px]">
                        {item?.related_blog_translations_id?.content_read_time}
                      </p>
                    </span>
                  </div>
                </div>
              </Link>
            )
          );
        })}
      </div>
    </div>
  );
};

export default RelatedArticles;
